/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  RE_INVITE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.reInvite',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'RE_INVITE' },
      },
    },
    RE_INVITE: {
      invoke: {
        id: 'reInviteUser',
        src: 'reInviteUser',
        onDone: {
          target: 'RE_INVITE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'RE_INVITE_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    RE_INVITE_SUCCESS: {
      on: {
        START: { target: 'RE_INVITE' },
      },
    },
    RE_INVITE_FAILED: {
      on: {
        START: { target: 'RE_INVITE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
